import { useMemo } from 'react'
import {
  useLocalRuntime,
  useRemoteThreadListRuntime,
  type AssistantRuntime,
} from '@assistant-ui/react'
import { useChatModelAdapter } from '@/runtime/chatRuntime'
import { threadListAdapter } from '@/runtime/threadListAdapter'
import { ThreadHistoryProvider } from '@/runtime/threadHistoryAdapter'

export function useChatAssistantRuntime(): AssistantRuntime {
  const chatModel = useChatModelAdapter()

  const adapter = useMemo(
    () => ({
      ...threadListAdapter,
      unstable_Provider: ThreadHistoryProvider,
    }),
    [],
  )

  return useRemoteThreadListRuntime({
    adapter,
    runtimeHook: () => useLocalRuntime(chatModel),
  })
}
